import * as React from 'react';
import { cn } from '../../lib/utils';

export interface LandingBenefit {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export interface LandingBenefitsGridProps extends React.HTMLAttributes<HTMLElement> {
  heading?: string;
  subheading?: string;
  benefits: LandingBenefit[];
  columns?: 2 | 3;
}

export const LandingBenefitsGrid = React.forwardRef<HTMLElement, LandingBenefitsGridProps>(
  (
    {
      className,
      heading = 'Features',
      subheading,
      benefits,
      columns = 3,
      ...props
    },
    ref
  ) => {
    const gridCols =
      columns === 2
        ? 'md:grid-cols-2'
        : 'md:grid-cols-2 lg:grid-cols-3';

    return (
      <section
        ref={ref}
        className={cn('py-20', className)}
        {...props}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <h2 className="text-3xl md:text-4xl font-bold mb-3">{heading}</h2>
            {subheading && (
              <p className="text-lg text-muted-foreground max-w-xl mx-auto">
                {subheading}
              </p>
            )}
          </div>

          <div className={cn('grid grid-cols-1 gap-6', gridCols)}>
            {benefits.map((item) => (
              <div
                key={item.title}
                className="bg-card border border-border rounded-xl p-6 hover:shadow-md transition-shadow"
              >
                <div className="w-11 h-11 bg-primary/10 rounded-lg flex items-center justify-center text-primary mb-4">
                  {item.icon}
                </div>
                <h3 className="font-semibold text-base mb-2">{item.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
);

LandingBenefitsGrid.displayName = 'LandingBenefitsGrid';
